import { WorkspaceDialogService } from '@affine/core/modules/dialogs';
import { useI18n } from '@affine/i18n';
import { useService } from '@toeverything/infra';
import { useCallback } from 'react';

import { readAppContainerPlanQuota } from './app-base-plan-pause';

/**
 * The plan button of a refusal above the plan quota of an App Container: it
 * opens the plan settings of the workspace. Any other error has none.
 */
export function usePlanQuotaRefusalActions() {
  const t = useI18n();
  const dialogs = useService(WorkspaceDialogService);
  return useCallback(
    (error: unknown) =>
      readAppContainerPlanQuota(error)
        ? [
            {
              key: 'choose-plan',
              label: t['com.streamlain.appBases.planQuota.choosePlan'](),
              onClick: () =>
                dialogs.open('setting', { activeTab: 'workspace:billing' }),
            },
          ]
        : undefined,
    [dialogs, t]
  );
}
